import React from "react";
import HeaderWithTag from "../../common/header_with_tag";
import ErrorCodesLink from "../../common/ErrorCodesLink";

function Appendix() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Appendix</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Appendix
                  </li>
                </ol>
              </div>
            </div>


            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-12" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Refund Type"
                          headerTag="refundType"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Refund Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Net</td>
                                <td>Net means without commission</td>
                              </tr>
                              <tr>
                                <td>Full</td>
                                <td>Full means with commission</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p className="text-muted text-14 mb-0">
                          Matched case-insensitively. A missing value returns DPI-4003.
                        </p>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Wallet Entities (type: wallet)"
                          headerTag="walletEntity"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Entity</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>EDAHAB</td>
                                <td>Edahab Mobile Money</td>
                              </tr>
                              <tr>
                                <td>MPESA</td>
                                <td>Mpesa Mobile Money</td>
                              </tr>
                              <tr>
                                <td>UGANDA</td>
                                <td>Uganda Mobile Wallets</td>
                              </tr>
                              <tr>
                                <td>TANZANIA</td>
                                <td>Tanzania Mobile Wallets</td>
                              </tr>
                              <tr>
                                <td>BANGLADESH</td>
                                <td>Bangladesh Mobile Wallets</td>
                              </tr>
                              <tr>
                                <td>PESALink</td>
                                <td>PESALink &mdash; also valid with the bank account type</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Bank Entities (type: bank)"
                          headerTag="bankEntity"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Entity</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>DMT</td>
                                <td>Dahabshiil Money Transfer</td>
                              </tr>
                              <tr>
                                <td>DBI</td>
                                <td>Dahabshil Bank International</td>
                              </tr>
                              <tr>
                                <td>EAB</td>
                                <td>East African Bank</td>
                              </tr>
                              <tr>
                                <td>PESALink</td>
                                <td>PESALink &mdash; also valid with the wallet account type</td>
                              </tr>
                              <tr>
                                <td>ABC</td>
                                <td>ABC bank account transfers</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Document Type"
                          headerTag="documentType"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Document Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Passport</td>
                              </tr>
                              <tr>
                                <td>Driving License</td>
                              </tr>
                              <tr>
                                <td>National ID</td>
                              </tr>
                              <tr>
                                <td>Travel Document</td>
                              </tr>
                              <tr>
                                <td>Other</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p className="text-muted text-14 mb-0">
                          Matched case-insensitively; the value must contain one of
                          Passport, Driving, National, Travel or Other. A missing value
                          returns DPI-1014; any other value returns DPI-1015.
                        </p>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Sender Type"
                          headerTag="senderType"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Sender Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Individual</td>
                              </tr>
                              <tr>
                                <td>Corporate</td>
                              </tr>
                              <tr>
                                <td>Charity</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p className="text-muted text-14 mb-0">
                          Matched case-insensitively. Any other value returns DPI-1006.
                        </p>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Sandbox Test Accounts"
                          headerTag="testAccounts"
                        />
                        <p className="text-muted text-14">
                          Accounts accepted by Validate Account in the sandbox. Any other
                          account number fails validation.
                        </p>
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Type</th>
                                <th>Entity</th>
                                <th>Account</th>
                                <th>Returned name</th>
                                <th>Returned agentId</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>wallet</td>
                                <td>EDAHAB</td>
                                <td>252654249184</td>
                                <td>Abdirazak Ibrahim Abdirahman</td>
                                <td>EDH</td>
                              </tr>
                              <tr>
                                <td>wallet</td>
                                <td>TANZANIA</td>
                                <td>255754123456</td>
                                <td>Test User</td>
                                <td>CRB</td>
                              </tr>
                              <tr>
                                <td>wallet</td>
                                <td>UGANDA</td>
                                <td>256772123456</td>
                                <td>Test User</td>
                                <td>YOB</td>
                              </tr>
                              <tr>
                                <td>wallet</td>
                                <td>BANGLADESH</td>
                                <td>8801712345678</td>
                                <td>Test User</td>
                                <td>GVP</td>
                              </tr>
                              <tr>
                                <td>wallet or bank</td>
                                <td>PESALink</td>
                                <td>255754123456</td>
                                <td>Test User</td>
                                <td>KMT</td>
                              </tr>
                              <tr>
                                <td>bank</td>
                                <td>ABC</td>
                                <td>255754123456</td>
                                <td>Test User</td>
                                <td>KPL</td>
                              </tr>
                              <tr>
                                <td>bank</td>
                                <td>DMT</td>
                                <td>HRGD0012</td>
                                <td>Farhan Harun</td>
                                <td>HRG</td>
                              </tr>
                              <tr>
                                <td>bank</td>
                                <td>DBI</td>
                                <td>201018078601</td>
                                <td>Abdirazak Ibrahim Abdirahman</td>
                                <td>DBF</td>
                              </tr>
                              <tr>
                                <td>bank</td>
                                <td>EAB</td>
                                <td>0987654321</td>
                                <td>Abdirazak Ibrahim Abdirahman</td>
                                <td>EAB</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p className="text-muted text-14 mb-0">
                          The EDAHAB wallet is also accepted as 0654249184, 654249184,
                          00252654249184 or +252 654 249 184. TANZANIA, UGANDA, BANGLADESH,
                          PESALink and ABC each accept any of 255754123456, 256772123456 and
                          8801712345678. For the Edahab numbers that return DPI-2007 and
                          DPI-2002, see the Validate Account page.
                        </p>
                      </div>
                      <ErrorCodesLink />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Appendix;
